import React from 'react';
import { Link } from '@material-ui/core';
import { IRowData } from './ReportList';
import settings from '../../services/settings';

const TEMPORARY_CREW_EXTERNAL_URL = settings.getCrewURI();

interface IProps {
  rowData: IRowData;
}

const UserCell = (props: IProps): JSX.Element => {
  const { rowData } = props;

  return (
    <Link component="a" variant="body2" target="_blank" href={`${TEMPORARY_CREW_EXTERNAL_URL}/users/${rowData.userId}`}>
      {rowData.userId}
    </Link>
  );
};

export default UserCell;
